import { useLocalStorage } from 'react-use';

import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';
import { useCurrentUser } from '@/modules/authentication/hooks/useCurrentUser';
import { localStorageBooleanSerializer } from '@/utils/localStorageSerializers';

export function useBraintrustLinks() {
  const currentUser = useCurrentUser();
  const [enabled, setEnabled] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.SHOW_BRAINTRUST_LINKS,
    false,
    localStorageBooleanSerializer
  );

  return {
    enabled: enabled === true,
    setEnabled,
    showDiagnosticLinks:
      currentUser?.isInternalUser === true && enabled === true,
  };
}
